import getDistance from 'geolib/es/getDistance'

export const distanceToCurrentLocation = (marketLocation, mapState) => {
  const formatDistance = distance => parseFloat(distance / 1000).toFixed(1)
  const location = getDistance(mapState.location, marketLocation)
  if (location === 0) return null
  return formatDistance(location).toString().replace('.', ',')
}
